export default {
  // These are events that caused the web-app to navigate to another page:
  // tapping the logo, sections in the sidebar menu, going back from a details page, etc.
  navigation(action, label) {
    gtag('event', action, {
      event_category: 'navigation',
      event_label: label,
    });
  },
  // Events where the user actually did something in the app: signed in, updated their profile information, etc.
  engagement(action, label) {
    gtag('event', action, {
      event_category: 'engagement',
      event_label: label,
    });
  },
  // These indicate user interaction with an element on the page, which doesn’t update any data in the backend.
  // For example, the user expanded a section, toggled a checkbox or opened the sidebar menu.
  interaction(action, label) {
    gtag('event', action, {
      event_category: 'interaction',
      event_label: label,
    });
  },
  // These are events that the user experienced, usually after something they did.
  // An example ‘experience’ event is when the user received a validation error, or a pop-up question came up asking for confirmation.
  // These don’t fall on any of the above categories and we’re sending them to Analytics mentioning that they’re non-interaction events.
  experience(action, label) {
    gtag('event', action, {
      event_category: 'experience',
      event_label: label,
      non_interaction: true,
    });
  },
  clickLink(label) {
    gtag('event', 'click_link', {
      event_category: 'navigation',
      event_label: label,
    });
  },
  clickButton(label) {
    gtag('event', 'click_button', {
      event_category: 'navigation',
      event_label: label,
    });
  },
}